import React from 'react';
import { toast } from 'react-toastify';

import { Button } from '@trussworks/react-uswds';
import TextInput from '@components/text-input/TextInput';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm, FormProvider } from 'react-hook-form';
import { DeveloperAccessService } from '@api/services/developer/service';
import { ResponseStatuses } from '@src/utils/enums';

const schema = yup.object().shape({
  createdDate: yup.string().required('Field is required'),
});

const JpaFileMetadataSync = () => {
  const defaultValues = {
    createdDate: null,
  };

  const methods = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(schema),
    mode: 'onBlur',
    stateOptions: [],
  });
  const {
    formState: { isValid },
    watch,
    trigger,
  } = methods;

  const createdDate = watch('createdDate');

  const handleSubmit = async () => {
    if (isValid) {
      const result = await DeveloperAccessService.jpaFileMetadataSync(createdDate);
      if (result.status === ResponseStatuses.Success) {
        toast.success(result.msg);
      } else {
        toast.error(result.msg);
      }
    } else {
      trigger();
      toast.error('Please fill out all required fields!');
    }
  };

  return (
    <FormProvider {...methods}>
      <div>
        <TextInput
          name='createdDate'
          label='Created Date'
          placeholder={createdDate}
          required
          type='date'
          style={{ width: '200px' }}
        />
        <Button title='Sync JPA File Metadata' size='small' onClick={handleSubmit} style={{ marginTop: '1rem' }}>
          Sync JPA File Metadata
        </Button>
      </div>
    </FormProvider>
  );
};

export default JpaFileMetadataSync;
